<template>
    <div class="setup-provider-info-card">
        <div class="setup-provider-info-card__header">
            <CompassColoredIcon :icon="icon" color="brand" />
            <span class="setup-provider-info-card__title typographies-paragraph-medium-bold">
                {{ title }}
            </span>
        </div>
        <div class="setup-provider-info-card__content">
            <slot />
        </div>
    </div>
</template>

<script setup>
defineProps({
    icon: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
});
</script>

<style lang="scss" scoped>
.setup-provider-info-card {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-3);
    padding: var(--spacing-3);
    border: 1px solid var(--colors-common-border-default);
    border-radius: var(--spacing-1);
    &__header {
        display: flex;
        align-items: center;
        gap: var(--spacing-1);
    }
    &__title {
        color: var(--colors-common-text-brand-secondary-blue);
    }
    &__content {
        display: flex;
        flex-wrap: wrap;
        gap: var(--spacing-0);
    }
}
</style>
